if (!customElements.get('sf-home-video-reels')) {
  customElements.define('sf-home-video-reels', class extends HTMLElement {
    connectedCallback() {
      this.visible = false;
      this.soundOn = false;
      this.userPaused = new WeakSet();
      this.onClick = this.handleClick.bind(this);
      this.onVisibility = () => this.sync();
      this.addEventListener('click', this.onClick, true);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.sync();
      }, {threshold: 0.15});
      this.observer.observe(this);
      this.timer = setInterval(() => {
        const container = this.querySelector('[data-swiper]');
        if (!container?.swiper) return;
        this.slider = container.swiper;
        this.onSlide = () => this.sync();
        this.slider.on('slideChange', this.onSlide);
        clearInterval(this.timer);
        this.sync();
      }, 250);
    }
    getVideo(slide, create = false) {
      if (!slide) return null;
      let video = slide.querySelector('video');
      if (!video && create) {
        const template = slide.querySelector('[data-video-template]');
        if (!template) return null;
        video = template.content.firstElementChild.cloneNode(true);
        template.parentElement.append(video);
        const button = slide.querySelector('.shoppable-video__control-button');
        const updateIcon = () => {
          button?.classList.toggle('shoppable-video__control-button--play', !video.paused);
          button?.classList.toggle('shoppable-video__control-button--pause', video.paused);
        };
        video.addEventListener('play', updateIcon);
        video.addEventListener('pause', updateIcon);
        updateIcon();
      }
      return video;
    }
    pauseOthers(active) {
      this.querySelectorAll('video').forEach(video => {
        if (video !== active) video.pause();
      });
    }
    play(video) {
      if (!video) return;
      this.pauseOthers(video);
      if (!video.getAttribute('src')) {
        const mobile = matchMedia('(max-width: 899px)').matches;
        const source = mobile ? video.dataset.mobileSrc : video.dataset.desktopSrc;
        if (!source) return;
        video.src = source;
        video.addEventListener('playing', () => {
          video.parentElement.classList.add('sf-video-started');
        });
      }
      video.muted = !this.soundOn;
      video.play().catch(() => {});
    }
    sync() {
      const activeSlide = this.slider?.slides[this.slider.activeIndex];
      this.querySelectorAll('[data-swiper-slide]').forEach(slide => {
        slide.classList.toggle('active', slide === activeSlide);
      });
      if (!this.visible || document.hidden) {
        this.pauseOthers(null);
        return;
      }
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches || navigator.connection?.saveData;
      const active = this.getVideo(activeSlide, !reduced);
      this.pauseOthers(active);
      if (!active || this.userPaused.has(active) || reduced) return;
      this.play(active);
    }
    handleClick(event) {
      const playButton = event.target.closest('.shoppable-video__control-button');
      const soundButton = event.target.closest('.wt-video__sound-toggle');
      if (!playButton && !soundButton) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const slide = event.target.closest('[data-swiper-slide]');
      const video = this.getVideo(slide, !!playButton);
      if (playButton && !video) return;
      if (soundButton) {
        this.soundOn = !this.soundOn;
        this.querySelector('[data-swiper]').dataset.sound = this.soundOn ? 'on' : 'off';
        this.querySelectorAll('video').forEach(item => { item.muted = !this.soundOn; });
        this.querySelectorAll('.wt-video__sound-toggle').forEach(button => {
          button.dataset.sound = this.soundOn ? 'on' : 'off';
          button.setAttribute('aria-pressed', String(this.soundOn));
        });
      } else if (video.paused) {
        this.userPaused.delete(video);
        this.play(video);
      } else {
        this.userPaused.add(video);
        video.pause();
      }
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.observer?.disconnect();
      this.slider?.off('slideChange', this.onSlide);
      this.removeEventListener('click', this.onClick, true);
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.pauseOthers(null);
    }
  });
}
